import { FormFieldWrapper } from "../../forms/FormField";
import { createPropertyField } from "../../../forms/propertyFields";
import { SignatureField } from "./SignatureField";
import { Stack } from "@mui/material";

export const SignatureFields = ({ field, control }) =>
    <FormFieldWrapper label={field.label}>
        <Stack spacing={2}>
            {field.signatureFields.map(property =>
                <SignatureField
                    key={property.uuid}
                    property={property}
                    athlete={field.athlete}
                    isSeriesRegistration={field.isSeriesRegistration}
                    control={control}
                    field={createPropertyField(property, field.basePath)}
                />
            )}
        </Stack>
    </FormFieldWrapper>;
